<app-checkout-layout
  [title]="'checkout.payment.title' | translate"
  [description]="'checkout.payment.description' | translate"
  [backLinkAriaLabel]="'checkout.payment.back_link' | translate"
  [backLink]="backLink"
  data-test="payment-page"
>
  <ng-container *ngIf="items">
    <app-checkout-payment-onepay
      *ngIf="onepayEnabled"
      [items]="items"
      class="checkout-payment__onepay"
      (submitPromoCode)="clearPromoCode()"
    ></app-checkout-payment-onepay>
  </ng-container>

  <div right-column #rightColumn>
    <app-checkout-summary
      *ngIf="!isMobileDevice"
      [items]="items"
      [isVatDisplayed]="true"
      [isCart]="false"
      (submitPromoCode)="clearPromoCode()"
    ></app-checkout-summary>

    <ng-container *flagIsTrue="paramethorNameEnum.PromoCode">
      <app-checkout-payment-promo-code
        [codeStatus]="promoCodeStatus"
        (submitPromoCode)="checkPromoCode($event)"
        (focusInput)="clearPromoCodeError()"
      ></app-checkout-payment-promo-code>
    </ng-container>

    <app-tips
      class="block mb-2 md:mb-3"
      [icon]="iconType.Wallet"
      [title]="'checkout.payment.aside.information_1.title' | translate"
      [tips]="'checkout.payment.aside.information_1.description' | translate"
    >
    </app-tips>

    <app-tips
      *ngIf="isBms"
      class="block mb-2 md:mb-3"
      [icon]="iconType.Information"
      [title]="'checkout.payment.aside.information_2.title.bms' | translate"
      [tips]="
        'checkout.payment.aside.information_2.description.bms'
          | translate: { refundTime: getFormattedRefundTime }
      "
    >
    </app-tips>

    <app-tips
      *ngIf="!isBms"
      class="block mb-2 md:mb-3"
      [icon]="iconType.Information"
      [title]="'checkout.payment.aside.information_2.title' | translate"
      [tips]="
        'checkout.payment.aside.information_2.description'
          | translate: { refundTime: getFormattedRefundTime }
      "
    >
    </app-tips>

    <app-tips
      class="block mb-2 md:mb-3"
      [icon]="iconType.Information"
      [title]="'checkout.payment.aside.information_3.title' | translate"
      [tips]="'checkout.payment.aside.information_3.description' | translate"
    >
    </app-tips>
  </div>
</app-checkout-layout>
